import { render, staticRenderFns } from "./TaskPerformanceAreaReportView.vue?vue&type=template&id=3053c658&scoped=true"
import script from "./TaskPerformanceAreaReportView.vue?vue&type=script&lang=js"
export * from "./TaskPerformanceAreaReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053c658",
  null
  
)

export default component.exports